/* 国际化zh_cn */

module.exports = {
  common: {
    password: "密码",
    emailLabel: "邮箱",
    emailInfoTxt: "请输入邮箱",
    rightEmail: "请输入正确的邮箱",
    acre: "公顷",
    spaceAcre: "公顷",
    submitTxt: "提交",
    passwordInfoTxt: "请输入密码",
    wrongPasswordTxt: "请输入由6-15位数字、字母组成的密码",
    footerText: "随时随地记录农场动态，与他人分享农场信息",
    bottomText: "管理当前重要事项，与农场成员更高效合作",
    pullingText: "下拉即可刷新...",
    loosingText: "释放即可刷新...",
    loadingText: "加载中...",
    exceptionText: "加载异常，请稍后再试",
    apiErrorText: "接口错误"
  },
  outsideInvite: {
    headerText: "加入农场",
    textTitle: "邀请你加入",
    invitation: "接受邀请"
  },
  outsideInviteDown: {
    textTitle: "恭喜，已加入",
    download: "下载App"
  },
  outsideInviteLogin: {
    login: "登录",
    forgetPassword: "忘记密码",
    remindInfo: "还没有账号？",
    resigsterInfo: "立即注册",
    welcomeTxt: "欢迎来到世界农场"
  },
  outsideInviteRegister: {
    createAccount: "创建账户",
    userName: "姓名",
    userNameInfo: "请输入姓名",
    agreementInfo: "请同意用户协议",
    confirmInfo: "我已经确认并同意",
    userProtol: "用户协议",
    registerInfo: "注册"
  },
  outsidePasswordEmail: {
    findPassword: "找回密码",
    desc: "我们将发送重置密码邮件到您输入的邮箱",
    errorTxt: "邮箱格式不正确，请重新输入",
    verifyTxt: "验证邮件已发送邮箱，请查收"
  },
  outsidePasswordReset: {
    passwordLabel: "新密码",
    passwordInfoTxt: "请输入新密码",
    cofirmInfoTxt: "确认密码",
    cofirmNewInfoTxt: "请输入确认新密码",
    wrongPasswordTxt: "密码不一致，请重新输入",
    resetPasswordTxt: "重置密码成功"
  },
  outsidePasswordVerify: {
    headerText: "邮箱验证",
    tipsMsg: "验证中",
    successTipMsg: "邮箱验证成功"
  },
  outsideMap: {
    farmText: "农场",
    HDMsg: "高清",
    lengthMsg: "长度",
    notesMsg: "备注",
    temMsg: "温度",
    humMsg: "湿度",
    pensLengthMsg: "围栏长度（千米）",
    pensAreaMsg: "围栏面积（公顷）"
  },
  appStatistics: {
    noFarm: "暂无农场",
    CattlesTit: "存栏牲畜",
    AbnormalTit: "活动异常牲畜",
    Abnormal: "活动异常牲畜",
    ExtraneousTit: "外部农场闯入",
    noLivestockData: "暂未添加牲畜",
    handleAbnormalMsg: "查看走出农场等异常牲畜",
    handleExtraneousTit: "查看非农场牲畜",
    openQuickSearch: "已开启找牛模式"
  },
  appArticle: {
    registerText: "注册协议",
    aboutUsText: "关于我们",
    uploadText: "手机上传"
  },
  appLivestockList: {
    reasonText: "原因：不在农场信号范围内",
    findCowTit: "快速找牛",
    daysMsg: "天",
    monthsMsg: "个月"
  }
};
